import script from "./Vaccine.vue?vue&type=script&setup=true&lang=js"
export * from "./Vaccine.vue?vue&type=script&setup=true&lang=js"

import "./Vaccine.vue?vue&type=style&index=0&id=4e978594&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e978594"]])

export default __exports__